import { getAccessToken } from "../Services/authToken";

export interface BookSlotPanelResponse {
  success: boolean;
  message: string;
  scheduled_date?: string;
  scheduled_start_time?: string;
  scheduled_end_time?: string;
  interviewer_name?: string;
  requisition_name?: string;
  interviewer_pairing_id: string;
}

const hostname = window.location.hostname;

export async function bookInterviewSlotPanel(
  interviewer_pairing_id: string
): Promise<BookSlotPanelResponse> {
  let baseurl = '';
  if (hostname.includes('localhost')) {
    baseurl = 'http://localhost:8080';
  } else if (hostname.includes('dev')) {
    baseurl = 'https://candidateinterviewscheduler-dev.pwc.com';
  } else if (hostname.includes('stg') || hostname.includes('stage')) {
    baseurl = 'https://candidateinterviewscheduler-stg.pwc.com';
  } else {
    baseurl = 'https://candidateinterviewscheduler.pwc.com';
  }

  const token = await getAccessToken();
  if (!token) {
    throw new Error('Authentication required - please log in');
  }

  const res = await fetch(`${baseurl}/api/candidate-dashboard/book-slot-panel`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ interviewer_pairing_id }),
  });

  console.log("Booking Response from BookSlotPanel:", res);
  if (!res.ok) throw new Error(`Panel booking failed: ${res.status} ${res.statusText}`);
  return res.json();
}